module.exports = __webpack_public_path__ + "img/bg-10.b0df5d54.jpg";